"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleSkeleton = exports.TEST_ID_ARTICLE_SKELETON = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var ArticleBase_1 = require("./ArticleBase");
exports.TEST_ID_ARTICLE_SKELETON = "article-skeleton";
function ArticleSkeleton(_a) {
    var _b = _a.articlePosition, articlePosition = _b === void 0 ? ArticleBase_1.ArticlePosition.MIDDLE : _b, csx = _a.csx;
    var pseudoStyles = {
        background: theme_1.theme.colors.grey800,
        content: "''",
        height: 2,
        left: 0,
        position: "absolute"
    };
    return (theme_ui_1.jsx(ArticleBase_1.ArticleBase, { backgroundColor: theme_1.theme.colors.grey900, includeGradient: false, articlePosition: articlePosition, csx: csx },
        theme_ui_1.jsx(theme_ui_1.Box, { "data-testid": exports.TEST_ID_ARTICLE_SKELETON, sx: {
                display: "block",
                height: "100%",
                position: "relative",
                width: "100%",
                "::before": __assign(__assign({}, pseudoStyles), { bottom: 0, width: "30%" }),
                "::after": __assign(__assign({}, pseudoStyles), { bottom: 3, width: "70%" })
            } })));
}
exports.ArticleSkeleton = ArticleSkeleton;
